<script setup>

import { reactive } from "vue";
import { Timestamp } from "firebase/firestore";

const emit = defineEmits(["onCreateEvent"]);

const form = reactive({
    name: "",
    description: "",
    startDate: "",
    endDate: "",
    location: "Kistan 2.0",
    imageUrl: null,
});

function submitEvent() {
    // Validate form data (basic validation)
    if (
        !form.name ||
        !form.description ||
        !form.startDate ||
        !form.endDate ||
        !form.location
    ) {
        alert("Please fill in all fields.");
        return;
    }

    function dateToTimestamp(dateStr) {
        const [year, month, day] = dateStr.split("-").map(Number);
        return Timestamp.fromDate(new Date(year, month - 1, day));
    }

    // Create event object
    const newEvent = {
        name: form.name,
        description: form.description,
        startDate: dateToTimestamp(form.startDate),
        endDate: dateToTimestamp(form.endDate),
        location: form.location,
        imageUrl: form.imageUrl,
    };

    // send upward to presenter
    emit("onCreateEvent", newEvent);

    // Reset form
    form.name = "";
    form.description = "";
    form.startDate = "";
    form.endDate = "";
    form.location = "Kistan 2.0";
    form.imageUrl = "";
}



</script>



<template>
    <div>
        <form @submit.prevent="submitEvent">
            <h1>Create an event!</h1>
            <p>Event Name: <input type="text" required v-model="form.name"
                    class="border border-gray-300 rounded px-2 py-1 bg-white"></p>
            <p>Event Description: <br><textarea required v-model="form.description" rows="6" cols="35"
                    class="border border-gray-300 rounded px-2 py-1 bg-white"></textarea></p>
            <hr>
            <p>StartDate: <input type="date" required v-model="form.startDate"
                    class="border border-gray-300 rounded px-2 py-1 bg-white"></p>
            <p>EndDate: <input type="date" required v-model="form.endDate"
                    class="border border-gray-300 rounded px-2 py-1 bg-white"></p>
            <hr>
            <p>Location: <input type="text" required v-model="form.location"
                    class="border border-gray-300 rounded px-2 py-1 bg-white" value="Kistan 2.0"></p>
            <p>Image URL: <input type="text" v-model="form.imageUrl"
                    class="border border-gray-300 rounded px-2 py-1 bg-white"></p>

            <p><button type="submit" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Create
                    Event</button></p>
        </form>
    </div>
</template>